import { Card, Language } from '@yleisradio/areena-types';
import { HeroControl } from './viewTypes';
import { getButtonText } from '../utils/buttonText';
import { getTranslation } from '../localizations/translations';
import { dataAttributeKeys } from './utils';
import { getRawLabel } from '../utils/labels';
import { idFromPointer } from '../utils/pointer';
import { DataAttributes } from '../appTypings';

export function parseAPICardHero(
  card: Card,
  isGeoBlocked: boolean,
  languageCode: Language,
  isBlocked: boolean,
  heroCardDataAttributes: DataAttributes | null
) {
  const heroControls: {
    heroControlPlay?: { control: HeroControl };
    heroControlInfo?: HeroControl;
  } = {};

  const playControl = card.controls?.find(c => c.tag === 'play');
  const pointer = card.pointer;
  const impressionViewDataLocation = '0:0';
  let controlCount = 0;

  if (playControl || (pointer && pointer.type !== 'package')) {
    const itemType = getRawLabel(card, 'itemtype');

    const play: HeroControl = {
      dataAttributes: {
        ...heroCardDataAttributes,
        ['data-testid']: 'hero-play-button',
      },
      title: undefined,
      destination: undefined,
      controlIndex: controlCount,
      isGeoBlocked,
      isBlocked,
    };

    if (playControl && playControl.destination && playControl.title) {
      play.destination = !isGeoBlocked ? playControl.destination : undefined;
      play.title = playControl.title;
    } else if (pointer && card.title) {
      play.destination = !isGeoBlocked ? pointer : undefined;
      play.title = getButtonText(
        isGeoBlocked,
        undefined,
        languageCode,
        itemType
      );
    }

    heroControls.heroControlPlay = {
      control: play,
    };
    controlCount += 1;
  }

  if (pointer && card.presentation !== 'broadcastCard') {
    heroControls.heroControlInfo = {
      dataAttributes: {
        ...heroCardDataAttributes,
        [dataAttributeKeys.impressionViewDataLocation]:
          impressionViewDataLocation,
        [dataAttributeKeys.impressionYleId]: idFromPointer(
          pointer ?? { uri: '' }
        ),
      },
      destination: pointer,
      title: getTranslation('common_info', languageCode),
      controlIndex: controlCount,
      isGeoBlocked,
      isBlocked,
    };
  }

  return heroControls;
}
